import { PropType, computed, defineComponent, onUnmounted, ref, watch } from 'vue'
import { Store } from 'pinia'
import { useRoute } from 'vue-router'
import { gcj02ToBd09 } from '@/utils/coordinateTransform'
import { getPowerResourceType } from '@/pages/chargermap/utils/resource'
import { distanceFormat } from '@/utils/distance'
import {
  Line,
  MapViewMode,
  Marker,
  MarkerType,
  Point,
  PowerRoute,
  ZoomMode,
} from '../../contract/map'
import { ChargeMapContext } from '../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { ResourceIconMap, ResourceIconSizeMap, ResourceIndexMap } from '../chargerMap/mapConfig'
import { changeMarker, fitBound } from '../chargerMap/mapUtils'
import { getChargeStationDetail, getPowerSwapDetail } from '../../apis/map.api'
import RecommendRouteDetail from './recommendRouteDetail'

export default defineComponent({
  name: 'route-route-detail-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },

  setup: (props, { expose }) => {
    const componentStore = computed(() => props.componentStore)
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    return () => (
      <>
        {componentStore.value.viewMode === MapViewMode.RecommendRouteDetail && (
          <RecommendRouteDetail
            mapContextRef={mapContextRef.value}
            mapInstance={mapInstance.value}
            componentStore={componentStore.value}
          ></RecommendRouteDetail>
        )}
      </>
    )
  },
})
